import { render, staticRenderFns } from "./contract-collapse.vue?vue&type=template&id=4371c73c&scoped=true"
import script from "./contract-collapse.vue?vue&type=script&lang=js"
export * from "./contract-collapse.vue?vue&type=script&lang=js"
import style0 from "./contract-collapse.vue?vue&type=style&index=0&id=4371c73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4371c73c",
  null
  
)

export default component.exports